export default __webpack_public_path__ + "static/media/redirect-await.0448e40d.png";